// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".-col-group-container{border-bottom:1px solid #ddd}", ""]);
// Exports
module.exports = exports;
